export default __webpack_public_path__ + "c3909e9969f36ead104b220f57737ba9.svg";